/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/core'
import { lighten } from 'polished'
import surveysLogo from '../../assets/icons/surveys-logo-lc.svg'

export const shine = keyframes`
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
`

const shineCss = css`
  background-image: linear-gradient(
    90deg,
    ${lighten(0.05, '#dde2e6')} 25%,
    ${'#dde2e6'} 37%,
    ${lighten(0.05, '#dde2e6')} 63%
  );
  animation: ${shine} 1.4s ease infinite;
  background-size: 400% 100%;
`

const skeletonQuestionCss = (width = 100) => css`
  border-radius: 10px;
  width: ${width}%;
  height: 20px;
  ${shineCss};
`

const Heading = ({ isLoading, options = {}, survey = {} }) => {
  return (
    <div className="heading">
      <a
        href={process.env.REACT_APP_SURVEYS_MARKETPLACE}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img className="surveys-logo" src={surveysLogo} alt="thank you" />
      </a>{' '}
      {isLoading ? (
        <div css={skeletonQuestionCss()} />
      ) : (
        <span>{options.title || survey.name || ''}</span>
      )}
    </div>
  )
}

export default Heading
